import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: 'Anuluj',
  save: 'Zatwierdź',
  title: 'Zmień status zaawansowania ankiety',
  labelText: 'Status zaawansowania ankiety',
});
